<template>
	<div v-if="isLoading">
		<md-card>
			<md-card-content>
				<collapse :collapse="collapseItems" icon="keyboard_arrow_down" color-collapse="success">
					<template slot="md-collapse-pane-1">
						<md-card class="bg-success">
							<md-card-content>
								<h3 class="card-category card-category-social" style="text-align: center"><i class="fas fa-list-ul" /> Job Description</h3>
								<h4 class="card-title">Job Name</h4>
								<p class="card-description">{{ job.name }}</p>

								<h4 class="card-title">Company Name</h4>
								<h4 style="margin-top: -1px; font-size: 15px">
									<a
										v-if="job.clientProfile.website"
										:href="job.clientProfile.website.startsWith('http') ? job.clientProfile.website : `//${job.clientProfile.website}`"
										target="_blank"
										>{{ job.companyName }}</a
									>
									<router-link v-else-if="auth" class="card-title" :to="{ name: 'view-client-profile', params: { id: job.clientAlias } }"
										><a>{{ job.companyName }}</a></router-link
									>
									<p v-else class="card-description">{{ job.companyName }}</p>
								</h4>

								<h4 class="card-title">Description</h4>
								<p class="card-description" v-html="micro === null ? 'No Description' : micro.description"></p>

								<h4 class="card-title">Job Category</h4>
								<p class="card-description">{{ skills === null ? 'Other' : skills.category }}</p>

								<h4 class="card-title">Skills Required</h4>
								<ul v-if="skills !== null">
									<li v-for="(skill, index) in skills.skills" :key="index" class="card-description">{{ skill.skillName }}</li>
								</ul>
							</md-card-content>
						</md-card>
					</template>
					<template slot="md-collapse-pane-2">
						<md-card class="bg-success">
							<md-card-content>
								<h3 class="card-category card-category-social" style="text-align: center"><i class="fas fa-dungeon"></i> Job Requirements</h3>
								<h4 class="card-title">Minimum Level of Education</h4>
								<p class="card-description">{{ job.education }}</p>

								<h4 class="card-title">Minimum Work Experience</h4>
								<p class="card-description">{{ job.experience }}</p>

								<div v-if="job && job.citizenship">
									<h4 class="card-title">Required Citizenship</h4>
									<p class="card-description" v-for="(citizenship, index) in job.citizenship" :key="index">{{ citizenship }}</p>
								</div>
							</md-card-content>
						</md-card>
					</template>
					<template slot="md-collapse-pane-3">
						<md-card class="bg-success">
							<md-card-content>
								<h3 class="card-category card-category-social centre"><i class="fas fa-clipboard-list"></i> Job Information</h3>
								<h4 class="card-title">Location</h4>
								<p class="card-description">{{ micro === null ? 'No Location' : micro.location }}</p>

								<h4 class="card-title">Application Deadline</h4>
								<p class="card-description">{{ job.applicationDeadline }}</p>

								<h4 v-if="job.jobType === 'Once-off Project/Task'" class="card-title">Estimated Duration</h4>
								<h4 v-else class="card-title">Working Days</h4>

								<p v-if="job.jobType === 'Once-off Project/Task' && micro !== null" class="card-description">{{ micro.duration }}</p>
								<ul v-else-if="micro !== null">
									<li v-for="days in micro.daysOfTheWeek" :key="days" class="card-description">{{ days }}</li>
								</ul>

								<h4 v-if="job.jobType === 'Internship' || job.jobType === 'Part-time'" class="card-title">Working Hours Per Week</h4>
								<p v-if="job.jobType === 'Internship' || job.jobType === 'Part-time'" class="card-description">
									{{ micro === null ? 'No Description' : micro.workingHours }}
								</p>
							</md-card-content>
						</md-card>
					</template>
					<template slot="md-collapse-pane-4">
						<md-card class="bg-success">
							<md-card-content>
								<h3 v-if="job.jobType === 'Once-off Project/Task'" class="card-category card-category-social centre"><i class="fas fa-wallet"></i> Budget</h3>
								<h3 v-else class="card-category card-category-social centre"><i class="fas fa-wallet"></i> Salary</h3>
								<h4 v-if="job.jobType === 'Once-off Project/Task'" class="card-title">Budget</h4>
								<h4 v-else class="card-title">Salary</h4>
								<p class="card-description">{{ formatBudget(micro) }}</p>
							</md-card-content>
						</md-card>
					</template>
				</collapse>
			</md-card-content>
		</md-card>
	</div>
</template>

<script>
import { Collapse } from '@/components';

export default {
	data() {
		return {
			isSubmission: false,
			isLoading: false,
		};
	},
	components: {
		Collapse,
	},
	computed: {
		collapseItems() {
			return [
				{ isShow: true, field: 'Job Description' },
				{ isShow: true, field: 'Job Requirements' },
				{ isShow: true, field: 'Job Information' },
				{ isShow: true, field: 'Salary' },
				{ isShow: this.isSubmission, field: 'Additional Submission' },
			];
		},
	},
	props: {
		job: { type: Object },
		micro: { type: Object },
		skills: { type: Object },
	},
	methods: {
		formatBudget(micro) {
			if (micro === null) {
				return;
			}
			let budget = '';
			if (micro?.budget?.min || micro?.budget?.max) {
				let { min, max } = micro.budget;
				budget = 'R' + min + ' ' + '-' + ' ' + 'R' + max;
				return budget;
			} else {
				budget = 'R' + micro.budget;
				return budget;
			}
		},
	},
	async mounted() {
		this.isLoading = true;
	},
};
</script>
